import axios from 'axios'
import { config } from './httpurl'
import qs from 'qs'


// 获取遥感日报列表
export const getReportsReq = (params) => {
  return axios({
    url: config.root + 'orbita_cloud/platform/rsdaily/rs-daily/page', 
    method: 'GET',
    params:params
  })
}

// 获取遥感日报详情
export const getReportsDetails = (id) => {
  return axios({
    url: config.root + 'orbita_cloud/platform/rsdaily/rs-daily/details/'+id, 
    method: 'GET',
  })
}